import { FontSizes } from "../const/baseTheme";
var calculateFontSizeforFooterButtons = function (isOnlyOneButtonPresent, isDropdownItem) {
    return isOnlyOneButtonPresent || isDropdownItem
        ? "".concat(FontSizes.smallRoot, "px")
        : "".concat(FontSizes.small, "px");
};
export default calculateFontSizeforFooterButtons;
//# sourceMappingURL=calculateFontSizeforFooterButtons.js.map